export const DISPENSARY_DEMO_LINK = `https://business.dutchie.com/get-started`;
export const REFER_A_DISPENSARY_LINK = 'https://try.dutchie.com/dispensary/referral/';
export const RELEASES_LINK = 'https://updates.dutchie.com/';
export const HELP_LINK = 'https://help.dutchie.com/';
export const PRODUCT_SUPPORT_LINK = 'https://support.dutchie.com/';
